import { render, staticRenderFns } from "./MedicalRequirementsPlanTestsEdit.vue?vue&type=template&id=06ad7fb4&scoped=true&"
import script from "./MedicalRequirementsPlanTestsEdit.vue?vue&type=script&lang=js&"
export * from "./MedicalRequirementsPlanTestsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ad7fb4",
  null
  
)

export default component.exports